<ng-container *ngTemplateOutlet="iconTemplate || defaultIconTemplate"></ng-container>
<ng-container *ngIf="!!title">
  <ng-container *ngIf="hasLongTitle; else h4">
    <h3 class="h5">{{ title }}</h3>
  </ng-container>
  <ng-template #h4>
    <h3 class="h4">{{ title }}</h3>
  </ng-template>
</ng-container>

<ng-content></ng-content>

<ng-template #defaultIconTemplate>
  <i nz-icon nzType="plus-circle"></i>
</ng-template>
